<template>
  <div>
    <div class="mb-3">
      <TicketStoreItem
        v-for="product in products"
        :key="product.id"
        :product="product"
        class="mb-2"
      />
    </div>
    <TicketStoreCart
      :products="products"
      :add_to_cart_text="add_to_cart_text"
      :tickets_text="tickets_text"
    />
  </div>
</template>

<script>
import TicketStoreItem from "./TicketStoreItem";
import TicketStoreCart from "./TicketStoreCart";

export default {
  components: {
    TicketStoreItem,
    TicketStoreCart,
  },
  props: {
    products_string: {
      type: String,
      required: true,
    },
    add_to_cart_text: {
      type: String,
      required: true,
    },
    tickets_text: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      products: [],
    };
  },
  mounted() {
    this.products = JSON.parse(this.products_string).map(p => p.product);
  },
};
</script>
